<template>
  <b-card>
    Environment Information
    <form class="col-md-6" v-on:submit.prevent="saveEnvInfo" v-if="portalEnv">
      <div class="form-group ">
        <label for="formGroupExampleInput">Name</label>
        <input
          type="text"
          class="form-control"
          id="name"
          placeholder="Name"
          v-model="portalEnv.name"
        >
      </div>
      <div class="form-group ">
        <label for="formGroupExampleInput">Environment</label>
        <input
          type="text"
          class="form-control"
          id="env"
          placeholder="Environment"
          v-model="portalEnv.env"
        >
      </div>
      <div class="form-group ">
        <label for="formGroupExampleInput">Link</label>
        <input
          type="text"
          class="form-control"
          id="link"
          placeholder="Link"
          v-model="portalEnv.link"
        >
      </div>
      <div class="form-group">
        <label for="formGroupExampleInput2">Details</label>
        <textarea
          class="form-control"
          id="details"
          rows="3"
          v-model="portalEnv.details"
        ></textarea>
      </div>
      <div class="form-group">
        <div class="custom-file">
          <input
            type="file"
            class="custom-file-input"
            id="imageFile"
            @change="previewImage"
            accept="images/*"
          >
          <label
            class="custom-file-label"
            for="customFile"
          >Choose file</label>
        </div>
      </div>
      <div class="form-group">
        <img
          :src="portalEnv.thumbnail"
          @error="altImg"
          class="thumbnail-size img-fluid img-thumbnail"
          id="imageThumb"
        />
      </div>
      <div class="form-group row">
        <div class="col-sm-10">
          <button
            type="submit"
            class="btn btn-primary"
          >Save</button>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-lg-12">
          <div class="alert alert-success" role="alert" v-if="saveDone">
              Successfully saved. <button type="button" class="btn btn-link" v-on:click="closeMe">Click here to close this form.</button>
          </div>
        </div>
      </div>
    </form>
  </b-card>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Home',
  props: {
  },
  data () {
    return {
      portalEnv: {},
      saveDone: false,
      loading: false,
      envId: '',
      altImage: require('@/assets/logo-highlight.png')
    };
  },
  created: function () {
    window.addEventListener('beforeunload', function (event) {
      event.returnValue = 'Are you sure you want to leave?';
    }, false);
    this.getPortalEnv();
  },
  methods: {
    getPortalEnv () {
      this.envId = this.$route.query.envid;

      axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/portal/' + this.envId, { responseType: 'json' })
        .then(res => {
          const receivedResp = res.data;
          if ('Success' === receivedResp.message) {
            this.portalEnv = receivedResp.data.portals[0];
          }
          this.initiatePortalEnv();
        })
        .catch(error => {
          console.log(error);
        });
      return this.portalEnv;
    },
    altImg (e) {
      e.target.src = this.altImage;
    },
    previewImage (e) {
      document.getElementById('imageThumb').src = URL.createObjectURL(e.target.files[0]);
    },
    saveEnvInfo () {
      this.envId = this.$route.query.envid;

      const fd = new FormData();
      fd.append('env', this.portalEnv.env);
      fd.append('name', this.portalEnv.name);
      fd.append('link', this.portalEnv.link);
      fd.append('details', this.portalEnv.details);

      this.portalEnv.thumbnail = document.getElementById('imageFile').files[0];

      fd.append('thumbnail', this.portalEnv.thumbnail);
      if (this.envId) {
        axios({
          method: 'patch',
          url: (process.env.VUE_APP_URL_UNIVERSAL_API + '/portal/' + this.envId),
          data: fd,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
          const receivedResp = res.data;
          if ('Success' === receivedResp.message) {
            this.portalEnv = receivedResp.data.portals[0];
            this.saveDone = true;
            window.opener.location.reload(false);
          }
        })
          .catch(error => console.log(error));
      } else {
        axios({
          method: 'post',
          url: (process.env.VUE_APP_URL_UNIVERSAL_API + '/portal/'),
          data: fd,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
          const receivedResp = res.data;
          if ('Success' === receivedResp.message) {
            this.portalEnv = receivedResp.data.portals[0];
            this.saveDone = true;
            window.opener.location.reload(false);
          }
        })
          .catch(error => console.log(error));
      }
    },
    closeMe () {
      window.close();
    },
    initiatePortalEnv () {
      if (!this.portalEnv) {
        this.portalEnv = {
          env: '',
          name: '',
          link: '',
          details: '',
          thumbnail: ''
        };
      }
    }
  }
};
</script>
<style>
.thumbnail-size {
  width: 58px;
  height: 60px;
}
</style>
